import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { loadingHtml: String };

  connect() {
    this.observer = new MutationObserver(this.handleMutations.bind(this));
    this.observer.observe(this.element, { childList: true, subtree: false });
    this.ensureLoadingDots();
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  handleMutations(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        this.ensureLoadingDots();
      }
    }
  }

  ensureLoadingDots() {
    if (this.element.innerHTML.trim() === '') {
      if (this.hasLoadingHtmlValue) {
        this.element.innerHTML = this.loadingHtmlValue;
      } else {
        this.element.innerHTML = `<div class="gen-loading-spinner small">
          <div class="gen-loading-spinner-bounce-1"></div>
          <div class="gen-loading-spinner-bounce-2"></div>
          <div class="gen-loading-spinner-bounce-3"></div>
        </div>`;
      }
    }
  }
}
